import { tiposPagamento } from './../../../../models/commons/TipoPagamentoModel';
import { statusPagamento } from './../../../../models/commons/StatusPagamentoModel';
import { formasPagamento } from './../../../../models/commons/FormaPagamentoModel';
import { TransacaoModel, TransacoesModel } from './../../../../models/cadastros/saude/TransacoesModel';
import { PageResultDTO, ServerSidePaging } from '@/api/commons/PageResult';
import { AtendimentoNotaFiscalModel, FiltroComprovanteTransferenciaModel } from './../../../../models/cadastros/saude/ComprovanteTransferenciaModel';
import { FiltroComprovanteTransferenciaDTO, AtendimentoNotaFiscalDTO, ConfirmarComprovanteTransferenciaDTO } from './../../../../api/cadastro/saude/ComprovanteTransferenciaDTO';
import { RetornoMensagemDTO } from '@/api/cadastro/saude/RetornoMensagemDTO';
import { servicosSaudeAtendimentoApi } from "@/api/ServicosSaudeAtendimentoApi";
import AtendimentoFiltro from "@/models/cadastros/saude/AtendimentoFiltro";
import { RetornoMensagemModel } from '@/models/cadastros/saude/RetornoMensagemModel';
import { PaginationModel } from "@/models/commons/PaginationModel";
import { OrcamentoModel } from "@/models/cadastros/saude/atendimento/orcamento/OrcamentoModel";
import EspecialidadeModel from '@/models/cadastros/saude/EspecialidadeModel';
import { EspecialidadeDTO } from '@/api/cadastro/saude/EspecialidadeDTO';
import { tiposAtendimentoList } from '@/models/cadastros/saude/TipoAtendimentoModel';
import { tiposRamoList } from '@/models/cadastros/saude/RamoModel';
import { statusContaPagarList } from '@/models/commons/StatusContaPagarModel';

class SaudeAtendimentoService {
  pesquisar(
    filtro: AtendimentoFiltro,
    options: PaginationModel,
    cpfPrestador: string,
    cnpjPrestador: string,
    tipoPessoa: string,
    serialize?: boolean
  ) {
    let page = 0;
    let cpfCnpjPrestador = "";
    if (tipoPessoa == "F") {
      cpfCnpjPrestador = cpfPrestador.replace(/\D/g, "");
    } else {
      cpfCnpjPrestador = cnpjPrestador.replace(/\D/g, "");
    }

    if (options?.page) {
      page = options?.page - 1;
    }

    const filtroDTO = {
      cpfCnpjPrestador: cpfCnpjPrestador,
      cpfPaciente: filtro?.cpfCliente?.replace(/\D/g, ""),
      dataFinal: filtro?.dataFim,
      dataInicial: filtro?.dataInicio,
      idEspecialidade: filtro?.especialidade?.id,
      nomePaciente: filtro?.nomeCliente,
      nomePrestador: filtro?.nomePrestador,
      numeroAtendimento: filtro?.numeroAtendimento,
      status: filtro?.status?.name,
      tipoAtendimento: filtro?.tipoAtendimento?.name,
      size: options?.itemsPerPage,
      page: page,
      sort: "data",
    };
    return servicosSaudeAtendimentoApi.pesquisarAtendimentos(filtroDTO, serialize);
  }

  obterDetalheAtendimento(id: number) {
    return servicosSaudeAtendimentoApi.obterAtendimentoPorId(id);
  }

  obterRequerimentoMedico(idAtendimento: number, fileName: string) {
    return servicosSaudeAtendimentoApi.obterZipRequerimentoMedico(idAtendimento, fileName);
  }

  obterDocumentosValorAdicional(nomeArquivo: string) {
    return servicosSaudeAtendimentoApi.obterZipDocumentosValorAdicional(nomeArquivo);
  }

  recusarSolicitacaoOrcamento(idAtendimento: number, justificativa: string): Promise<RetornoMensagemModel> {
    return servicosSaudeAtendimentoApi.recusarSolicitacaoOrcamento(idAtendimento, {justificativa})
    .then((retornoDTO: RetornoMensagemDTO) => {
      return Object.assign({} as RetornoMensagemModel, retornoDTO);
    });
  }

  aprovarSolicitacaoOrcamento(idAtendimento: number, observacao: string, idEspecialidade?: number): Promise<RetornoMensagemModel> {
    return servicosSaudeAtendimentoApi.aprovarSolicitacaoOrcamento(idAtendimento, {observacao, idEspecialidade})
    .then((retornoDTO: RetornoMensagemDTO) => {
      return Object.assign({} as RetornoMensagemModel, retornoDTO);
    });
  }

  incluirOrcamento(idAtendimento: number, orcamento: OrcamentoModel): Promise<RetornoMensagemModel> {
    return servicosSaudeAtendimentoApi.incluirOrcamento(idAtendimento, {
      observacao: orcamento.observacao,
      descricao: orcamento.descricao,
      idPrestador: orcamento.prestador?.id,
      dataAtendimento: orcamento.dataAgendamento,
      horaAtendimento: orcamento.horaAgendamento,
      valorPrestador: Number(orcamento.valorPrestador.replace(/\./g, "").replace(/,/g, ".")),
      estimativaValorAdicional: Number((orcamento.valorAdicionalEstimado || "0").replace(/\./g, "").replace(/,/g, ".")),
      valorAssociado: Number(orcamento.valorAssociado.replace(/\./g, "").replace(/,/g, "."))
    })
    .then((retornoDTO: RetornoMensagemDTO) => {
      return Object.assign({} as RetornoMensagemModel, retornoDTO);
    });
  }

  recusarValorAdicional(idAtendimento: number, observacao: string): Promise<RetornoMensagemModel> {
    return servicosSaudeAtendimentoApi.recusarValorAdicional(idAtendimento, { observacao })
    .then((retornoDTO: RetornoMensagemDTO) => {
      return Object.assign({} as RetornoMensagemModel, retornoDTO);
    });
  }

  aprovarValorAdicional(idAtendimento: number, observacao: string): Promise<RetornoMensagemModel> {
    return servicosSaudeAtendimentoApi.aprovarValorAdicional(idAtendimento, { observacao })
    .then((retornoDTO: RetornoMensagemDTO) => {
      return Object.assign({} as RetornoMensagemModel, retornoDTO);
    });
  }

  pesquisarEspecialidadesRemocao(idCidade: number, ramo: string, tipoAtendimento: string): Promise<EspecialidadeModel[]> {
    return servicosSaudeAtendimentoApi.pesquisarEspecialidadesRemocao({
              idCidade,
              ramo,
              tipoAtendimento
            })
            .then((especialidadesDTO: EspecialidadeDTO[]) => {
              return especialidadesDTO.map(especialidadeDTO => {
                return {
                  id:especialidadeDTO.id,
                  nome: especialidadeDTO.nome,
                  tipoAtendimento: tiposAtendimentoList.find(tipoAtendimento => tipoAtendimento.name === especialidadeDTO.tipoAtendimento),
                  ramo: tiposRamoList.find(ramo => ramo.name === especialidadeDTO.ramo),
                  orientacaoPreparo: especialidadeDTO.orientacaoPreparo
                }
              })
            });
  }

  public pesquisarComprovantes(filtro: FiltroComprovanteTransferenciaDTO): Promise<ServerSidePaging<AtendimentoNotaFiscalDTO>> {
    return servicosSaudeAtendimentoApi.pesquisarComprovantesTransferencia(filtro);
  }

  public obterNomeComprovante(idAtendimento: number): Promise<string> {
    return servicosSaudeAtendimentoApi.obterNomeComprovante(idAtendimento);
  }

  public downloadComprovante(nomeArquivo: string): Promise<any> {
    return servicosSaudeAtendimentoApi.downloadComprovante(nomeArquivo);
  }
 
  public confirmarComprovante(payload: ConfirmarComprovanteTransferenciaDTO): Promise<any> {
    return servicosSaudeAtendimentoApi.confirmarComprovante(payload);
  }

  public obterPagamentos(idAtendimento: number): Promise<TransacoesModel> {
    return servicosSaudeAtendimentoApi.obterPagamentos(idAtendimento)
      .then(resp => {
        console.log(resp);
        const transacoesMaped = {
          tentativasDePagamentoDoValorAdicional: resp?.tentativasDePagamentoDoValorAdicional ?? resp.transacoes?.filter(transacao => transacao.tipoDePagamento === 'VALOR_ADICIONAL_EXTRA').length,
          transacoes: resp.transacoes?.map((transacao) => {
            return {
              captura: transacao.captura,
              codigoRetorno: transacao.codigoRetorno,
              dataCriacao: transacao.dataCriacao,
              formaDePagamento: formasPagamento.find(fP => fP.name === transacao.formaDePagamento) || {name: transacao.formaDePagamento, descricao: 'Não identificado'},
              mensagemRetorno: transacao.mensagemRetorno,
              nossoNumero: transacao.nossoNumero,
              numeroCartao: transacao.numeroCartao,
              numeroParcelas: transacao.numeroParcelas,
              status: statusPagamento.find(sP => sP.name === transacao.status) || {name: transacao.status, descricao: 'Pagamento não realizado'},
              tipoDePagamento: tiposPagamento.find(tP => tP.name === transacao.tipoDePagamento) || {name: transacao.tipoDePagamento, descricao: 'Não identificado'},
              valor: transacao.valor,
              valorCapturado: transacao.valorCapturado,
              valorCapturadoEmCentavos: transacao.valorCapturadoEmCentavos,
              valorEmCentavos: transacao.valorEmCentavos
            };
          })
        };

        return transacoesMaped;
      });
  }
}

export const saudeAtendimentoService = new SaudeAtendimentoService();
